module.exports = __webpack_public_path__ + "media/images/icons/outlined/pause-circle-014a1217bd3611e4e3dc2db283b6552a.svg";